<template>
    <flex-container
        align-items="center"
        class="template-info-title"
        size="auto"
    >
        <template-icon :icon="props.icon" />

        <text-decorator
            :size="FontSize.lg"
            bold
            style="line-height: 1.4rem"
        >
            {{ props.title }}
        </text-decorator>

        <!-- flex-container mist justify-self: end -->
        <div style="flex-grow: 1" />

        <template-price-chip :price="props.price" />
    </flex-container>
</template>

<script setup lang="ts">
    import { FontSize, TextDecorator, FlexContainer } from '@keyvue/one-ui';
    import TemplateIcon from '@/flow/template/components/TemplateIcon.vue';
    import TemplatePriceChip from '@/flow/template/components/TemplatePriceChip.vue';

    interface Props {
        icon: string,
        title: string,
        price: number | string,
    }

    const props = defineProps<Props>();
</script>

<style scoped lang="scss">
.template-info-title {
    padding: size(md) size(md) size(sm);
}
</style>
